import React from 'react';
import ModuleBase from '../../components/ModuleBase/ModuleBase';
import StyledButton from '../../components/SingleButton';
import '../../../../styles/animations.scss';

const BottomButton = ({ data, onEdit, style = {}, onChange }) => {
    const moduleStyle = {
        position: 'absolute',
        bottom: data.bottom || '20px',
        display: 'grid',
        placeItems: 'center',
        left: 0,
        right: 0,
        zIndex: 100,
        padding: '8px',
        minHeight: 'auto'
    };

    return (
        <ModuleBase onEdit={onEdit} style={moduleStyle} onChange={onChange} className={data.animation === 'pulse' ? 'pulse' : data.animation === 'bounce' ? 'bounce' : ''}>
            <a
                href={data?.link}
                target="_blank"
                rel="noopener noreferrer"
                style={{ textDecoration: 'none' }}
                onClick={(e) => {
                    if (!data?.link) {
                        e.preventDefault();
                    }
                }}
            >
                <StyledButton data={data} style={style} />
            </a>
        </ModuleBase>
    );
};

export default BottomButton;